module.exports = __webpack_public_path__ + "img/testimonial-image@3x.ddd1ce3d.png";